import { map } from 'lodash'

import { COMPONENT_INGREDIENT_TYPES } from '../../../common/constants'

const transformToUpdateDishTypeAdditionalIngredientsDetailsArgs = data => [
  ...map(data.definiteIngredientIds, ({ value: id }) => ({
    id,
    type: COMPONENT_INGREDIENT_TYPES.DEFINITE,
  })),
  ...map(data.probableIngredientIds, ({ value: id }) => ({
    id,
    type: COMPONENT_INGREDIENT_TYPES.PROBABLE,
  })),
]

export default transformToUpdateDishTypeAdditionalIngredientsDetailsArgs
